import { render, staticRenderFns } from "./commonIndex.vue?vue&type=template&id=4c4600fc&lang=pug"
import script from "./commonIndex.vue?vue&type=script&lang=js"
export * from "./commonIndex.vue?vue&type=script&lang=js"
import style0 from "./commonIndex.vue?vue&type=style&index=0&id=4c4600fc&prod&lang=css"
import style1 from "./commonIndex.vue?vue&type=style&index=1&id=4c4600fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports